module.exports = __webpack_public_path__ + "img/sld_acb_box.dcd8744e.svg";